module.exports = __webpack_public_path__ + "static/media/sy.d648066b.svg";